import { render, staticRenderFns } from "./ChooseParcousToUnlock.vue?vue&type=template&id=6ff333a9&scoped=true&"
import script from "./ChooseParcousToUnlock.vue?vue&type=script&lang=js&"
export * from "./ChooseParcousToUnlock.vue?vue&type=script&lang=js&"
import style0 from "./ChooseParcousToUnlock.vue?vue&type=style&index=0&id=6ff333a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff333a9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
